var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-code',{attrs:{"apiname":"webcategory","idname":"webCategoryId","labelname":"รหัสหมวดหมู่หน้าเว็บ"}})}
var staticRenderFns = []

export { render, staticRenderFns }